import React from 'react';

import { ButlerFeaturesAndQuotasLink } from './ButlerFeaturesAndQuotasLink';
// eslint-disable-next-line @trello/less-matches-component
import supplementStyles from './NotificationSupplement.less';

export const ButlerQuotaApproachingMemberSupplement = () => {
  return (
    <div className={supplementStyles.quotaSupplementText}>
      {ButlerFeaturesAndQuotasLink}
    </div>
  );
};
